"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconLaneControlFilled = function IconLaneControlFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 6H3V16H7V6Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 20H3V30H7V20Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 34H3V44H7V34Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47 6H43V16H47V6Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47 20H43V30H47V20Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47 34H43V44H47V34Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25 9C21.8355 9 18.7421 9.93838 16.1109 11.6965C13.4797 13.4546 11.4289 15.9534 10.2179 18.8771C9.00693 21.8007 8.69008 25.0177 9.30744 28.1214C9.92481 31.2251 11.4487 34.0761 13.6863 36.3137C15.9239 38.5513 18.7749 40.0752 21.8786 40.6926C24.9823 41.3099 28.1993 40.9931 31.1229 39.7821C34.0466 38.5711 36.5454 36.5203 38.3035 33.8891C40.0616 31.2579 41 28.1645 41 25C41 20.7565 39.3143 16.6869 36.3137 13.6863C33.3131 10.6857 29.2435 9 25 9ZM21.8 36C21.8013 36.0635 21.7875 36.1264 21.7597 36.1835C21.7319 36.2407 21.6909 36.2903 21.6401 36.3285C21.5893 36.3666 21.5301 36.392 21.4675 36.4027C21.4049 36.4134 21.3406 36.4091 21.28 36.39C19.7753 35.9008 18.3821 35.1188 17.1808 34.0891C15.9795 33.0594 14.9936 31.8022 14.28 30.39C14.2492 30.3288 14.2346 30.2607 14.2376 30.1923C14.2406 30.1238 14.2612 30.0573 14.2974 29.999C14.3335 29.9408 14.384 29.8929 14.444 29.8598C14.504 29.8267 14.5715 29.8095 14.64 29.81H17.8C18.8609 29.81 19.8783 30.2314 20.6284 30.9816C21.3786 31.7317 21.8 32.7491 21.8 33.81V36ZM25 29C24.5253 29 24.0613 28.8592 23.6666 28.5955C23.272 28.3318 22.9643 27.957 22.7827 27.5184C22.601 27.0799 22.5535 26.5973 22.6461 26.1318C22.7387 25.6662 22.9673 25.2386 23.303 24.9029C23.6386 24.5673 24.0662 24.3387 24.5318 24.2461C24.9973 24.1535 25.4799 24.201 25.9184 24.3827C26.357 24.5643 26.7318 24.872 26.9955 25.2666C27.2593 25.6613 27.4 26.1253 27.4 26.6C27.4013 26.9155 27.3402 27.2282 27.22 27.52C27.0999 27.8118 26.9231 28.0769 26.7 28.3C26.4769 28.5231 26.2118 28.6999 25.92 28.82C25.6282 28.9401 25.3155 29.0013 25 29ZM35.72 30.38C34.9412 31.9239 33.8401 33.2826 32.491 34.3643C31.1419 35.446 29.5763 36.2255 27.9 36.65C27.8408 36.6633 27.7794 36.6634 27.7203 36.6501C27.6611 36.6368 27.6056 36.6106 27.5577 36.5733C27.5099 36.536 27.4709 36.4886 27.4437 36.4344C27.4164 36.3802 27.4015 36.3206 27.4 36.26V33.8C27.4 32.7391 27.8214 31.7217 28.5716 30.9716C29.3217 30.2214 30.3391 29.8 31.4 29.8H35.4C35.4651 29.8059 35.5277 29.8277 35.5825 29.8635C35.6372 29.8993 35.6823 29.9479 35.7139 30.0051C35.7454 30.0623 35.7625 30.1264 35.7636 30.1918C35.7647 30.2571 35.7497 30.3218 35.72 30.38ZM36.4 24.38L30.69 22.23C28.9062 21.4061 26.9648 20.9794 25 20.9794C23.0352 20.9794 21.0938 21.4061 19.31 22.23L13.6 24.4C13.5375 24.4235 13.47 24.431 13.4038 24.4218C13.3376 24.4125 13.2748 24.3868 13.2211 24.347C13.1674 24.3072 13.1245 24.2546 13.0964 24.194C13.0682 24.1334 13.0557 24.0667 13.06 24C13.3571 21.0398 14.7433 18.2955 16.9496 16.2996C19.1559 14.3037 22.0249 13.1985 25 13.1985C27.9751 13.1985 30.8441 14.3037 33.0504 16.2996C35.2567 18.2955 36.6429 21.0398 36.94 24C36.9443 24.0667 36.9318 24.1334 36.9036 24.194C36.8755 24.2546 36.8326 24.3072 36.7789 24.347C36.7252 24.3868 36.6624 24.4125 36.5962 24.4218C36.53 24.431 36.4626 24.4235 36.4 24.4V24.38Z",
    fill: color
  }));
};

IconLaneControlFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconLaneControlFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconLaneControlFilled;
exports.default = _default;